module.exports = __webpack_public_path__ + "static/low-rate-pl-hero-95c95b24349ff2cfaac53017e66d886b.jpg";